"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = void 0;
var stylex = _interopRequireWildcard(require("@stylexjs/stylex"));
var _tokensStylex = require("web/shared/tokens.stylex.js");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const styles = exports.styles = {
  page: {
    flexShrink: "x2lah0s",
    $$css: true
  },
  stickyTop: {
    position: "x7wzq59",
    top: "x13vifvy",
    zIndex: "xhtitgo",
    backgroundColor: "xk6p4me",
    paddingTop: "x1iul6r4",
    paddingBottom: "x2yie3v",
    marginBottom: "x1eq25fj",
    marginLeft: "xetejkq x19s5pqj",
    marginInlineStart: null,
    marginInlineEnd: null,
    marginRight: "xgbycy8 x1gkozr6",
    paddingLeft: "x1vua2ax x1i3jmcq",
    paddingInlineStart: null,
    paddingInlineEnd: null,
    paddingRight: "xnywu7s x1rvzbc9",
    borderBottomWidth: "xso031l",
    borderBottomStyle: "x1q0q8m5",
    borderBottomColor: "x1mqwo74",
    $$css: true
  },
  searchRow: {
    display: "x78zum5",
    alignItems: "x6s0dn4",
    gap: "x1uma3xh",
    rowGap: null,
    columnGap: null,
    $$css: true
  },
  pickerContainer: {
    position: "x1n2onr6",
    flexShrink: "x2lah0s",
    $$css: true
  },
  pickerButton: {
    appearance: "xjyslct",
    cursor: "x1ypdohk",
    display: "x3nfvp2",
    alignItems: "x6s0dn4",
    justifyContent: "xl56j7k",
    width: "xzijgnt",
    height: "x14cnqhc",
    boxSizing: "x9f619",
    borderWidth: "xmkeg23",
    borderInlineWidth: null,
    borderInlineStartWidth: null,
    borderLeftWidth: null,
    borderInlineEndWidth: null,
    borderRightWidth: null,
    borderBlockWidth: null,
    borderTopWidth: null,
    borderBottomWidth: null,
    borderStyle: "x1y0btm7",
    borderInlineStyle: null,
    borderInlineStartStyle: null,
    borderLeftStyle: null,
    borderInlineEndStyle: null,
    borderRightStyle: null,
    borderBlockStyle: null,
    borderTopStyle: null,
    borderBottomStyle: null,
    borderColor: "x1agr7sc xun8cwn",
    borderInlineColor: null,
    borderInlineStartColor: null,
    borderLeftColor: null,
    borderInlineEndColor: null,
    borderRightColor: null,
    borderBlockColor: null,
    borderTopColor: null,
    borderBottomColor: null,
    borderRadius: "x16rqkct",
    borderStartStartRadius: null,
    borderStartEndRadius: null,
    borderEndStartRadius: null,
    borderEndEndRadius: null,
    borderTopLeftRadius: null,
    borderTopRightRadius: null,
    borderBottomLeftRadius: null,
    borderBottomRightRadius: null,
    backgroundColor: "xjbqb8w",
    color: "x10kmngs",
    transition: "x11m0sca",
    transitionBehavior: null,
    transitionDelay: null,
    transitionDuration: null,
    transitionProperty: null,
    transitionTimingFunction: null,
    $$css: true
  },
  pickerBackdrop: {
    position: "xixxii4",
    inset: "x10a8y8t",
    insetInline: null,
    insetInlineStart: null,
    insetInlineEnd: null,
    left: null,
    right: null,
    insetBlock: null,
    top: null,
    bottom: null,
    backgroundColor: "xjbqb8w",
    borderWidth: "xc342km",
    borderInlineWidth: null,
    borderInlineStartWidth: null,
    borderLeftWidth: null,
    borderInlineEndWidth: null,
    borderRightWidth: null,
    borderBlockWidth: null,
    borderTopWidth: null,
    borderBottomWidth: null,
    padding: "x1717udv",
    paddingInline: null,
    paddingStart: null,
    paddingLeft: null,
    paddingEnd: null,
    paddingRight: null,
    paddingBlock: null,
    paddingTop: null,
    paddingBottom: null,
    cursor: "xt0e3qv",
    zIndex: "x52sccv",
    $$css: true
  },
  pickerPopover: {
    position: "x10l6tqk",
    top: "x1kq3sn5",
    right: "x3m8u43",
    insetInlineStart: null,
    insetInlineEnd: null,
    zIndex: "x1355qak",
    width: "xk3fz3t",
    boxSizing: "x9f619",
    backgroundColor: "xk6p4me",
    borderWidth: "xmkeg23",
    borderInlineWidth: null,
    borderInlineStartWidth: null,
    borderLeftWidth: null,
    borderInlineEndWidth: null,
    borderRightWidth: null,
    borderBlockWidth: null,
    borderTopWidth: null,
    borderBottomWidth: null,
    borderStyle: "x1y0btm7",
    borderInlineStyle: null,
    borderInlineStartStyle: null,
    borderLeftStyle: null,
    borderInlineEndStyle: null,
    borderRightStyle: null,
    borderBlockStyle: null,
    borderTopStyle: null,
    borderBottomStyle: null,
    borderColor: "x1agr7sc",
    borderInlineColor: null,
    borderInlineStartColor: null,
    borderLeftColor: null,
    borderInlineEndColor: null,
    borderRightColor: null,
    borderBlockColor: null,
    borderTopColor: null,
    borderBottomColor: null,
    borderRadius: "x4pepcl",
    borderStartStartRadius: null,
    borderStartEndRadius: null,
    borderEndStartRadius: null,
    borderEndEndRadius: null,
    borderTopLeftRadius: null,
    borderTopRightRadius: null,
    borderBottomLeftRadius: null,
    borderBottomRightRadius: null,
    boxShadow: "x1xrhixj",
    padding: "x1uz70x1",
    paddingInline: null,
    paddingStart: null,
    paddingLeft: null,
    paddingEnd: null,
    paddingRight: null,
    paddingBlock: null,
    paddingTop: null,
    paddingBottom: null,
    display: "x78zum5",
    flexDirection: "xdt5ytf",
    gap: "x1rq4zhh",
    rowGap: null,
    columnGap: null,
    $$css: true
  },
  pickerTitle: {
    fontSize: "xgommxb",
    textTransform: "xtvhhri",
    letterSpacing: "x2ujxvm",
    color: "xcdm7ny",
    $$css: true
  },
  swatchRow: {
    display: "x78zum5",
    gap: "x1rcpt3j",
    rowGap: null,
    columnGap: null,
    $$css: true
  },
  swatch: {
    position: "x1n2onr6",
    width: "xs5h3dt",
    height: "xettwda",
    borderRadius: "x116uinm",
    borderStartStartRadius: null,
    borderStartEndRadius: null,
    borderEndStartRadius: null,
    borderEndEndRadius: null,
    borderTopLeftRadius: null,
    borderTopRightRadius: null,
    borderBottomLeftRadius: null,
    borderBottomRightRadius: null,
    borderWidth: "xmkeg23",
    borderInlineWidth: null,
    borderInlineStartWidth: null,
    borderLeftWidth: null,
    borderInlineEndWidth: null,
    borderRightWidth: null,
    borderBlockWidth: null,
    borderTopWidth: null,
    borderBottomWidth: null,
    borderStyle: "x1y0btm7",
    borderInlineStyle: null,
    borderInlineStartStyle: null,
    borderLeftStyle: null,
    borderInlineEndStyle: null,
    borderRightStyle: null,
    borderBlockStyle: null,
    borderTopStyle: null,
    borderBottomStyle: null,
    borderColor: "x1agr7sc",
    borderInlineColor: null,
    borderInlineStartColor: null,
    borderLeftColor: null,
    borderInlineEndColor: null,
    borderRightColor: null,
    borderBlockColor: null,
    borderTopColor: null,
    borderBottomColor: null,
    overflow: "xb3r6kr",
    overflowX: null,
    overflowY: null,
    cursor: "x1ypdohk",
    $$css: true
  },
  swatchInput: {
    position: "x10l6tqk",
    inset: "x10a8y8t",
    insetInline: null,
    insetInlineStart: null,
    insetInlineEnd: null,
    left: null,
    right: null,
    insetBlock: null,
    top: null,
    bottom: null,
    width: "xh8yej3",
    height: "x5yr21d",
    opacity: "xg01cxk",
    cursor: "x1ypdohk",
    $$css: true
  },
  presetRow: {
    display: "x78zum5",
    flexWrap: "x1a02dak",
    gap: "x1neeqzj",
    rowGap: null,
    columnGap: null,
    $$css: true
  },
  presetButton: {
    appearance: "xjyslct",
    cursor: "x1ypdohk",
    fontFamily: "x1wl88yq",
    fontSize: "x1qzg9v8",
    color: "x10kmngs x1qfsr1m",
    backgroundColor: "xjbqb8w",
    borderWidth: "xmkeg23",
    borderInlineWidth: null,
    borderInlineStartWidth: null,
    borderLeftWidth: null,
    borderInlineEndWidth: null,
    borderRightWidth: null,
    borderBlockWidth: null,
    borderTopWidth: null,
    borderBottomWidth: null,
    borderStyle: "x1y0btm7",
    borderInlineStyle: null,
    borderInlineStartStyle: null,
    borderLeftStyle: null,
    borderInlineEndStyle: null,
    borderRightStyle: null,
    borderBlockStyle: null,
    borderTopStyle: null,
    borderBottomStyle: null,
    borderColor: "x1agr7sc xun8cwn",
    borderInlineColor: null,
    borderInlineStartColor: null,
    borderLeftColor: null,
    borderInlineEndColor: null,
    borderRightColor: null,
    borderBlockColor: null,
    borderTopColor: null,
    borderBottomColor: null,
    borderRadius: "x1e6avla",
    borderStartStartRadius: null,
    borderStartEndRadius: null,
    borderEndStartRadius: null,
    borderEndEndRadius: null,
    borderTopLeftRadius: null,
    borderTopRightRadius: null,
    borderBottomLeftRadius: null,
    borderBottomRightRadius: null,
    paddingTop: "x1iul6r4",
    paddingBottom: "xes99ow",
    paddingLeft: "x1c0nefy",
    paddingInlineStart: null,
    paddingInlineEnd: null,
    paddingRight: "x1q13et5",
    transition: "xfms6eu",
    transitionBehavior: null,
    transitionDelay: null,
    transitionDuration: null,
    transitionProperty: null,
    transitionTimingFunction: null,
    $$css: true
  },
  grid: {
    display: "xrvj5dj",
    gridTemplateColumns: "x1m0xkz2",
    gap: "x8fetqu",
    rowGap: null,
    columnGap: null,
    $$css: true
  },
  card: {
    display: "x78zum5",
    flexDirection: "xdt5ytf",
    alignItems: "x6s0dn4",
    gap: "x1rkdry8",
    rowGap: null,
    columnGap: null,
    borderWidth: "xmkeg23",
    borderInlineWidth: null,
    borderInlineStartWidth: null,
    borderLeftWidth: null,
    borderInlineEndWidth: null,
    borderRightWidth: null,
    borderBlockWidth: null,
    borderTopWidth: null,
    borderBottomWidth: null,
    borderStyle: "x1y0btm7",
    borderInlineStyle: null,
    borderInlineStartStyle: null,
    borderLeftStyle: null,
    borderInlineEndStyle: null,
    borderRightStyle: null,
    borderBlockStyle: null,
    borderTopStyle: null,
    borderBottomStyle: null,
    borderColor: "x1agr7sc",
    borderInlineColor: null,
    borderInlineStartColor: null,
    borderLeftColor: null,
    borderInlineEndColor: null,
    borderRightColor: null,
    borderBlockColor: null,
    borderTopColor: null,
    borderBottomColor: null,
    borderRadius: "x4pepcl",
    borderStartStartRadius: null,
    borderStartEndRadius: null,
    borderEndStartRadius: null,
    borderEndEndRadius: null,
    borderTopLeftRadius: null,
    borderTopRightRadius: null,
    borderBottomLeftRadius: null,
    borderBottomRightRadius: null,
    paddingTop: "x138h7i8",
    paddingBottom: "x2yie3v",
    paddingLeft: "x14ffaay",
    paddingInlineStart: null,
    paddingInlineEnd: null,
    paddingRight: "x1afqadn",
    backgroundColor: "xjbqb8w",
    fontFamily: "x1wl88yq",
    cursor: "x1ypdohk",
    $$css: true
  },
  stageButton: {
    padding: "x1717udv",
    paddingInline: null,
    paddingStart: null,
    paddingLeft: null,
    paddingEnd: null,
    paddingRight: null,
    paddingBlock: null,
    paddingTop: null,
    paddingBottom: null,
    borderWidth: "xc342km",
    borderInlineWidth: null,
    borderInlineStartWidth: null,
    borderLeftWidth: null,
    borderInlineEndWidth: null,
    borderRightWidth: null,
    borderBlockWidth: null,
    borderTopWidth: null,
    borderBottomWidth: null,
    backgroundColor: "xjbqb8w",
    cursor: "x1ypdohk",
    borderRadius: "xur7f20",
    borderStartStartRadius: null,
    borderStartEndRadius: null,
    borderEndStartRadius: null,
    borderEndEndRadius: null,
    borderTopLeftRadius: null,
    borderTopRightRadius: null,
    borderBottomLeftRadius: null,
    borderBottomRightRadius: null,
    outlineWidth: "x1k57tk5 x784prv",
    outlineStyle: "xaatb59",
    outlineColor: "x1yrgfsk",
    outlineOffset: "x2wh2y9",
    $$css: true
  },
  nameRow: {
    display: "x3nfvp2",
    alignItems: "x6s0dn4",
    gap: "x1neeqzj",
    rowGap: null,
    columnGap: null,
    $$css: true
  },
  stage: {
    display: "x3nfvp2",
    color: "x10kmngs",
    transitionProperty: "xt3l3uh",
    transitionDuration: "xx6bhzk",
    transitionTimingFunction: "xwji4o3",
    $$css: true
  },
  stageHovered: {
    color: "x19p3n1p",
    $$css: true
  },
  name: {
    fontSize: "x1ksoetq",
    fontWeight: "x1s688f",
    color: "x10kmngs",
    $$css: true
  },
  hints: {
    fontSize: "xgommxb",
    color: "xcdm7ny",
    textAlign: "x2b8uid",
    $$css: true
  },
  ramp: {
    display: "x78zum5",
    flexWrap: "xozqiw3",
    alignItems: "xuk3077",
    justifyContent: "xl56j7k",
    columnGap: "x1ryjahz",
    color: "xcdm7ny",
    borderTopWidth: "x178xt8z",
    borderTopStyle: "x13fuv20",
    borderTopColor: "x1a6tffd",
    paddingTop: "xc22wi9",
    width: "xh8yej3",
    $$css: true
  },
  rampItem: {
    display: "x3nfvp2",
    flexDirection: "xdt5ytf",
    alignItems: "x6s0dn4",
    gap: "xvh977a",
    rowGap: null,
    columnGap: null,
    $$css: true
  },
  rampIcon: {
    display: "x3nfvp2",
    alignItems: "x6s0dn4",
    justifyContent: "xl56j7k",
    height: "x10w6t97",
    $$css: true
  },
  rampLabel: {
    fontFamily: "x1e2v2p8",
    fontSize: "x1sfrptf",
    color: "xcdm7ny",
    $$css: true
  }
};